import React, { useState } from "react";
import ModalPage from "./ModalPage";
import { Button } from "react-bootstrap";

const API_IMG = "https://image.tmdb.org/t/p/w500/";

//Constantes para imagenes de corazon
const fullHeart = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    fill='currentColor'
    className='bi bi-heart-fill'
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z'
    />
  </svg>
);
const emptyHeart = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    fill='currentColor'
    className='bi bi-heart'
    viewBox='0 0 16 16'>
    <path d='m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z' />
  </svg>
);

const Moviebox = ({
  id,
  title,
  poster_path,
  overview,
  vote_average,
  release_date,
  isFavorite,
  handleFavorite,
}) => {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <div className='card text-center bg-secendary mb-3'>
      <div className='card body'>
        <img className='card-img-top' src={API_IMG + poster_path} alt={title} />
        <Button
          variant='contained'
          className='btn btn-outline-danger'
          size='medium'
          onClick={() => {
            handleFavorite(id, isFavorite);
          }}>
          {isFavorite ? fullHeart : emptyHeart}
        </Button>
        <div className='card-body'>
          <button type='button' className='btn btn-dark' onClick={handleShow}>
            view more
          </button>

          <ModalPage
            title={title}
            vote_average={vote_average}
            release_date={release_date}
            API_IMG={API_IMG}
            poster_path={poster_path}
            overview={overview}
            show={show}
            handleClose={handleClose}
          />
          {/* TODO:
          Crear componente para el modal
          limpiar codigo */}
          {/* <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <img
                className='card-img-top'
                style={{ width: "14rem" }}
                src={API_IMG + poster_path}
                alt={title}
              />
              <h3>{title}</h3>
              <h4>IMDb: {vote_average}</h4>
              <h5>Release Date: {release_date}</h5>
              <br></br>
              <h6>Overview</h6>
              <p>{overview}</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal> */}
        </div>
      </div>
    </div>
  );
};
export default Moviebox;
